import { ContentfulImage, TemplateWrapper } from "@2u-landing-pages/components";
import {
  TypeProgram_variationWithoutUnresolvableLinksResponse,
  TypeProgramWithoutUnresolvableLinksResponse,
} from "@2u-landing-pages/types";
import { renderFooterText, renderMark } from "@2u-landing-pages/utils/contentful-richtext";
import EventClient from "@2u-landing-pages/utils/event-client";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, INLINES } from "@contentful/rich-text-types";
import { Body, Container } from "@red-digital/bricks";
import cn from "classnames";
import React from "react";

import styles from "./Footer.module.scss";

interface FooterProps {
  variation: TypeProgram_variationWithoutUnresolvableLinksResponse;
  program: TypeProgramWithoutUnresolvableLinksResponse;
}

export const Footer: React.FC<FooterProps> = ({ variation, program }) => {
  const hasDrawer = Boolean(variation?.fields?.drawer);
  const isExeced = Boolean(variation?.metadata?.tags.find((tag) => tag.sys.id === "execed"));

  const handleExternalLinkClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    EventClient.elementClicked({
      webElement: {
        elementType: "Landing Page",
        htmlId: event.currentTarget.href,
        location: "Footer",
        name: event.currentTarget.innerText,
        position: "",
        text: "",
      },
    });
  };

  return (
    <TemplateWrapper
      as="footer"
      padded
      className={cn(styles.footer, {
        [styles.hasDrawer]: hasDrawer,
      })}
    >
      <Container flex direction="column" justifyContent="space-between" lg={{ direction: "row", alignItems: "center" }}>
        <div className={styles.image}>
          <ContentfulImage image={variation?.fields?.logo_secondary || variation?.fields?.logo_primary} width={400} />
        </div>
        {program?.fields?.footer_content && (
          <div>
            {documentToReactComponents(program?.fields?.footer_content, {
              renderMark,
              renderNode: {
                [BLOCKS.PARAGRAPH]: (node, children) => (
                  <Body type="div" variant="caption-lg" className={styles.content}>
                    {children}
                  </Body>
                ),
                [INLINES.HYPERLINK]: (node: any) => {
                  const { uri } = node?.data;
                  const content = node?.content?.[0];
                  if (content && "value" in content) {
                    return (
                      <a href={uri} target="_blank" rel="noopener noreferrer" onClick={handleExternalLinkClick}>
                        {content.value}
                      </a>
                    );
                  }
                  return null;
                },
              },
              renderText: (text) => renderFooterText(text, program?.fields?.phone_number, isExeced),
              preserveWhitespace: true,
            })}
          </div>
        )}
      </Container>
    </TemplateWrapper>
  );
};
